<template>
    <div>
        <div class="filter-box" v-if="isTableMounted">
            <div class="d-flex mb-4 px-3 px-sm-4">
                <b-form-group class="text-left label font-weight-normal search-field mb-0">
                    <b-input-group class="username-input-field">
                        <b-form-input type="text" :placeholder="$t('maintenanceShared.search')" v-model="filterFields.search" class="unit f-12"
                            @keyup.enter="getRecurringScheduleData()"></b-form-input>
                        <b-input-group-append>
                            <b-button variant="primary" @click="getRecurringScheduleData()">
                                <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M6.14286 11.7857C8.98318 11.7857 11.2857 9.48318 11.2857 6.64286C11.2857 3.80254 8.98318 1.5 6.14286 1.5C3.30254 1.5 1 3.80254 1 6.64286C1 9.48318 3.30254 11.7857 6.14286 11.7857Z"
                                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 10.5L13 13.5" stroke="white" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </div>
        </div>
        <div v-if="!isTableMounted" class="mt-2" style="height: calc(100vh - 225px); overflow: hidden;">
            <b-skeleton-table :rows="17" :columns="7"
                :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
        </div>
        <b-table v-else class="mt-2" responsive :fields="translatedFields" :items="items" hover :current-page="currentPage"
            :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :no-local-sorting="true" :busy.sync="isBusy"
            :sticky-header="'calc(100vh - 330px)'"
            :show-empty="emptyTable">
            <template #cell(action)="data">
                <svg @click="recordID = data.item.id" class="mr-4 cursor-pointer" width="18" height="18"
                            viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5.52719 16.7477L14.5274 7.74753L10.2525 3.4726L1.25226 12.4728C1.12836 12.5969 1.04034 12.7522 0.997548 12.9222L0 18L5.07684 17.0025C5.2473 16.9598 5.40322 16.8717 5.52719 16.7477V16.7477ZM17.4329 4.84205C17.796 4.47881 18 3.98622 18 3.4726C18 2.95898 17.796 2.46639 17.4329 2.10315L15.8968 0.567123C15.5336 0.203994 15.041 0 14.5274 0C14.0138 0 13.5212 0.203994 13.1579 0.567123L11.6219 2.10315L15.8968 6.37808L17.4329 4.84205Z"
                                fill="#2CCE89" />
                        </svg>
                <svg v-if="allowDeleteRecord" @click="showDeletePopup(data.item.id)" class="cursor-pointer" width="19" height="20"
                    viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path
                        d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                        stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                        stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </template>
        </b-table>
        <div class="entries-pagination px-0 px-sm-2" v-if="isTableMounted">
            <div class="d-flex align-items-center flex-wrap">
                <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                    <b-form-select v-model="perPage" :options="pageOptions" />
                </div>
                <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">{{ positionText }}</p>
                <div class="pagination">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                        aria-controls="my-table"></b-pagination>
                </div>
            </div>
        </div>
        <AddRecurringSchedule @close="$emit('close')" :allowAddRecurringSchedule="allowAddRecurringSchedule"
            @recordAdded="getRecurringScheduleData()" />
        <EditRecurringSchedule :recordID="recordID" @resetEditRecord="recordID = null"
            @recordUpdated="getRecurringScheduleData()" 
            :allowUpdateRecord="allowUpdateRecord"
            />
        <DeleteModal v-if="showDeleteModal" @confirm="deleteItem($event)" />
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import AddRecurringSchedule from './AddRecurringSchedule.vue';
import DeleteModal from "@/components/DeleteModal.vue";
import EditRecurringSchedule from './EditRecurringSchedule.vue';
export default {
    name: "RecurringSchedule",
    components: { AddRecurringSchedule, DeleteModal, EditRecurringSchedule },
    props: ["allowAddRecurringSchedule"],
    data() {
        return {
            emptyTable: false,
            recordID: null,
            perPage: 10,
            items: [],
            pageOptions: [
                {
                    value: 10,
                    text: "10",
                },
                {
                    value: 25,
                    text: "25",
                },
                {
                    value: 50,
                    text: "50",
                },
                {
                    value: 100,
                    text: "100",
                },
            ],
            positionText: "",
            rows: 0,
            currentPage: 1,
            itemId: null,
            showDeleteModal: false,
            isBusy: false,
            isTableMounted: false,
            sortBy: undefined,
            sortDesc: undefined,
            filterFields: {
                search: ''
            }
        }
    },
    computed: {
        ...mapGetters(["userCompany","rolePermissions"]),
        translatedFields() {
            return [
                { key: "description", label: this.$t('recurringSched.columnDescription'), sortable: true, field: "text", thClass: 'font-table-weight-bold' },
                { key: "interval", label: this.$t('recurringSched.columnInterval'), sortable: true, field: "text", thClass: 'font-table-weight-bold' },
                { key: "units", label: this.$t('recurringSched.columnUnits'), sortable: true, visible: true, disabled: false, field: "text", thClass: 'font-table-weight-bold' },
                { key: "action", label: this.$t('recurringSched.columnAction'), sortable: true, thClass: 'font-table-weight-bold' },
            ];
        },
        allowUpdateRecord() {
            return this.rolePermissions && this.rolePermissions['Maintenance'] && this.rolePermissions['Maintenance'][1].allow
        },
        allowDeleteRecord() {
            return this.rolePermissions && this.rolePermissions['Maintenance'] && this.rolePermissions['Maintenance'][3].allow
        }
    },
    watch: {
        perPage: {
            async handler() {
                await this.getRecurringScheduleData();
            },
            immediate: true,
        },
        currentPage: {
            async handler() {
                await this.getRecurringScheduleData();
            },
        },
        sortBy: {
            async handler() {
                await this.getRecurringScheduleData();
            },
        },
        sortDesc: {
            async handler() {
                await this.getRecurringScheduleData();
            },
        },
        filterFields: {
            handler() {
                this.currentPage = 1
            },
            deep: true
        },
    },
    methods: {
        ...mapActions(['getRecurringSchedule', 'deleteRecurringSchedule', "setLoader", "setNotification"]),
        showDeletePopup(id) {
            this.showDeleteModal = true;
            this.itemId = id;
        },
        deleteItem(item) {
            if (item) {
                this.deleteRecord(this.itemId);
            }
            this.showDeleteModal = false;
        },
        async deleteRecord(id) {
            try {
                this.setLoader(true)
                await this.deleteRecurringSchedule(`${id}/`);
                await this.setNotification({
                    msg: this.$t('recurringSched.deleted'),
                    type: "success",
                    color: "green",
                });
                await this.getRecurringScheduleData()
                this.setLoader(false)
            } catch (error) {
                this.setLoader(false)
                await this.setNotification({
                    msg: error,
                    type: "error",
                    color: "red",
                });
            }
        },
        async getRecurringScheduleData() {
            try {
                this.isBusy = true
                let url = ""
                Object.keys(this.filterFields).map((key) => {
                    if (this.filterFields[key] !== '') {
                        url += `${key}=${this.filterFields[key]}&`
                    }
                })
                if (this.sortBy) {
                    url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
                }
                else {
                    url += `sort_field=description&sort_order=desc&`
                }
                url += `page=${this.currentPage}&page_size=${this.perPage}`
                const data = await this.getRecurringSchedule(url);
                if (data.total_entries) {
                    this.rows = data.total_entries
                    const start = this.currentPage === 1 ? 1 : (this.perPage * (this.currentPage - 1)) + 1
                    const end = this.perPage * (this.currentPage - 1) + data.queryset_count
                    this.positionText = this.$t('maintenanceShared.positionText', { start, end, total: data.total_entries })
                }
                else {
                    this.rows = 0
                    this.positionText = this.$t('maintenanceShared.emptyPosition')
                }
                this.items = []
                data.records.forEach((item) => {
                    this.items.push({
                        id: item.id,
                        description: item.description,
                        interval: item.interval_type === '2' ? item.interval.toLocaleString() + " " + this.$t('recurringSched.miles') : item.interval + " " + this.$t('recurringSched.days'),
                        units: item.total_units
                    })
                })
                if (this.items.length === 0) this.emptyTable = true
                else this.emptyTable = false
                this.isBusy = false
                this.isTableMounted = true
            }
            catch (e) {
                console.log(e)
                this.isBusy = false
                this.isTableMounted = true
            }
        }
    },
}
</script>